export default {
    resources: handleResources
};
function handleResources(newSourceInput, calendar, deepEqual) {
    var oldSourceInput = calendar.state.resourceSource._raw;
    if (!deepEqual(oldSourceInput, newSourceInput)) {
        calendar.dispatch({
            type: 'RESET_RESOURCE_SOURCE',
            resourceSourceInput: newSourceInput
        });
    }
}
